import React, { useState, useEffect, useContext, useReducer, useRef} from 'react';
import { Link } from 'react-router-dom';
import { Typeahead } from 'react-bootstrap-typeahead';
import MaterialTable, { MTableToolbar } from 'material-table';
import {
    Container, createMuiTheme, Toolbar, Typography, CssBaseline, IconButton,
    Checkbox, Snackbar, FormControl, FormControlLabel, InputLabel, Select, Divider, Fab, Grid, AppBar
} from '@material-ui/core';
import { MuiPickersUtilsProvider, KeyboardDatePicker, KeyboardDateTimePicker } from '@material-ui/pickers';
import { ThemeProvider } from '@material-ui/styles';
import { makeStyles } from '@material-ui/core/styles';
import Backdrop from '@material-ui/core/Backdrop';
import CircularProgress from '@material-ui/core/CircularProgress';
import MuiAlert from '@material-ui/lab/Alert';
import KeyboardBackspaceIcon from '@material-ui/icons/KeyboardBackspace';
import CloseIcon from '@material-ui/icons/Close';
import AddIcon from '@material-ui/icons/Add';
import EditIcon from '@material-ui/icons/Edit';
import 'date-fns';
import moment from 'moment';
import DateFnsUtils from '@date-io/date-fns';
import { ConvertToCurrentTimeZone } from '../header/timeFormatter';
import { HttpService } from '../../apiAuthorization/httpService';
import { OfflineService } from "../../offline/storageService/offlineService";
import { GlobalTheme } from '../../layouts/theme';
import { Context } from '../contexts/siteContext';
import { Theme } from '../contexts/themeContext';
import { AssignedToUsers } from '../contexts/assignedToUsers.js';
import { TransactionTime } from '../common/transactionTime';
import Card from '../card/card.js';
import CardBody from '../card/cardBody.js';
import RecoveryEVSAdd from './recoveryEVSAdd';
import SmallMenu from '../header/smallMenu';
import StatusIcon from '../common/statusIcon';

function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
};

const useStyles = makeStyles(theme => ({
    root: {
        '& > *': {
            margin: '7px 0px',
            width: '100%'
        }
    },
    button: {
        width: '15%',
        float: 'right'
    },
    error: {
        fontSize: '12px',
        fontWeight: "bold",
        color: 'red',
        marginTop: '-5px'
    },
    backdrop: {
        zIndex: theme.zIndex.drawer + 1,
        color: '#fff'
    },
    title: {
        flex: 1
    }
}));

export default function RecoveryEVSList(props) {
    const classes = useStyles();
    const offlineService = new OfflineService();
    const recoveryRef = useRef();
    const { defaultSite } = useContext(Context);
    const { theme } = useContext(Theme);
    const { assignedUsers, getAssignedToUsers } = useContext(AssignedToUsers);
    const [selectedDate, setSelectedDate] = useState(ConvertToCurrentTimeZone(new Date(), "MM/DD/YYYY", null, defaultSite));
    const [visitDate, setVisitDate] = useState(ConvertToCurrentTimeZone(new Date(), "MM/DD/YYYY hh:mm a", null, defaultSite));
    const [selectedLocation, setSelectedLocation] = useState(props.siteLocation ? props.siteLocation : []);
    const [locations, setLocations] = useState([]);
    const [recordToBeEdit, setRecordToBeEdit] = useState([]);
    const [visitation, setVisitation] = useState(null);
    const [open, setOpen] = useState(false);
    const [openSuccess, setOpenSuccess] = useState(false);
    const [backDrop, setBackDrop] = useState(false);
    const [successMessage, setSuccessMessage] = useState('');
    const [action, setAction] = useState('');
    const [modified, setModified] = useState(false);
    const currentTheme = theme ? createMuiTheme(GlobalTheme[theme]) : createMuiTheme(GlobalTheme[localStorage.getItem("theme")]);
    const tableHeight = window.innerHeight - 400;
    const [appVisitationTypes, setAppVisitationTypes] = useReducer((state, newState) => ({ ...state, ...newState }),
        {
            yesNo: [],
            followUps: [],
            issueTypes: [],
            priorityTypes: []
        });
    const [visitationRecovery, setVisitationRecovery] = useState(
        {
            AppVisitationRecovery: 0,
            SiteId: defaultSite.id,
            GeoLocation: 0,
            VisitDate: ConvertToCurrentTimeZone(new Date(), "MM/DD/YYYY hh:mm a", null, defaultSite),
            IssueTypeId: 0,
            PriorityId: 0,
            Resolved: false
        });
    const [recoveries, setRecoveries] = useState({
        columns: [
            { field: 'GeoLocationName', title: 'Location', width: '40%', render: rowData => getShortName((rowData.GeoLocationName)) },
            { field: 'IssueTypeName', title: 'Issue Type', width: '15%' },
            { field: 'PriorityName', title: 'Priority', width: '5%' },
            { field: 'VisitDateString', title: 'Start Date', width: '10%' },
            { field: 'ResolvedDateString', title: 'End Date', width: '10%' },
            { field: 'Resolved', title: 'Status', width: '10%', render: rowData => rowData.Resolved ? 'Closed' : 'Open'},
            { field: 'AppVisitation', title: 'Visit Id', width: '10%' }
        ],
        data: []
    });

    const triggerSave = () => {
        recoveryRef.current.save();
    };

    const rowStyle = (rowData, rowIndex) => {
        return { backgroundColor: rowIndex % 2 === 0 ? '' : currentTheme.alternateGridRow };
    };

    const getShortName = (name) => {
        if (name.indexOf("\\") === -1)
            return name;
        else
            return ".." + name.substring(name.indexOf("\\"));
    };

    const closeSuccessSnackbar = () => {
        setOpenSuccess(false);
        setSelectedLocation([]);
    };

    const openAddVisitation = () => {
        setOpen(true);
        setAction('Add');
        setRecordToBeEdit([]);
        setVisitDate(ConvertToCurrentTimeZone(new Date(), "MM/DD/YYYY hh:mm a", null, defaultSite));
    };

    const closeAddVisitation = () => {
        TransactionTime.cancel();
        setModified(false);
        if (visitation !== null) {
            props.history.push({ pathname: '/VisitationEVSList' });
        }
        else {
            setOpen(false);
            setRecordToBeEdit([]);
            setSelectedLocation([]);
            reset();
            setAction('');
            setSelectedDate(ConvertToCurrentTimeZone(new Date(), "MM/DD/YYYY", null, defaultSite));
        }
    };

    const reset = () => {
        setVisitationRecovery({
            ...visitationRecovery,
            AppVisitationRecovery: 0,
            SiteId: defaultSite.id,
            GeoLocation: 0,
            VisitDate: ConvertToCurrentTimeZone(new Date(), "MM/DD/YYYY hh:mm a", null, defaultSite),
            IssueTypeId: 0,
            PriorityId: 0,
            Resolved: false
        });
    };

    const inputValueChanged = () => {
        setModified(true);
    };

    const dateChanged = date => {
        date = moment(date).format("MM/DD/YYYY hh:mm a");
        setVisitationRecovery({ ...visitationRecovery, VisitDate: date });
        setSelectedDate(date);
    };

    const visitDateChanged = date => {
        setVisitDate(moment(date).format("MM/DD/YYYY hh:mm a"));
        recoveryRef.current.valueChanged();
        setModified(true);
    };

    const locationChanged = (e) => {
        setSelectedLocation(e);
        if (e.length > 0) {
            setVisitationRecovery({ ...visitationRecovery, GeoLocation: e[0]?.id });
        }
        else {
            setVisitationRecovery({ ...visitationRecovery, GeoLocation: 0 });
        }

        if (action === "Add" || action === "Edit") {
            recoveryRef.current.valueChanged();
            setModified(true);
        }
    };

    const editRecovery = (event, rowData) => {
        setRecordToBeEdit(rowData);
        setOpen(true);
        setAction('Edit');
        setVisitationRecovery({
            ...visitationRecovery,
            GeoLocation: rowData.GeoLocation,
            IssueTypeId: rowData.IssueTypeId,
            PriorityId: rowData.PriorityId
        });
        setVisitDate(rowData.VisitDate);
        var location = locations.filter(x => x.id === rowData.GeoLocation);
        setSelectedLocation(location);
    };

    const updateList = (item) => {
        if (item !== null) {
            const data = recoveries.data;
            var loc = locations.filter(l => l.id === item.GeoLocation);
            item.GeoLocationName = loc[0].name;
            let index = appVisitationTypes.issueTypes.findIndex(type => type.AppVisitationTypeId === item.IssueTypeId);
            item.IssueTypeName = appVisitationTypes.issueTypes[index].Title;
            index = appVisitationTypes.priorityTypes.findIndex(type => type.AppVisitationTypeId === item.PriorityId);
            item.PriorityName = appVisitationTypes.priorityTypes[index].Title;
            index = data.findIndex(d => d.AppVisitationRecoveryId === item.AppVisitationRecoveryId);
            if (index === -1)
                data.push(item);
            else
                data[index] = item;
            setRecoveries({ ...recoveries, data: data });
        }
        setSuccessMessage("Recovery EVS is saved Successfully.");
        setOpenSuccess(true);
    };

    const getLocations = () => {
        setBackDrop(true);
        HttpService.post('/VisitationLog/GetGeoLocationBranchVisits', {
            Date: selectedDate,
            Key: "GetAll",
            MaxId: -1,
            Site: defaultSite.id,
            GetAll: true
        })
        .then(async (result) => {
            if (result && result.offline) {
                //get offline data
                const offlineResult = await offlineService.getOfflinesBySite(defaultSite.id, "GeoLocationBranchVisits");
                result.data = offlineResult.OfflineData.data;
            }
            else {
                offlineService.removeOfflineBySite(defaultSite.id, "GeoLocationBranchVisits");
                offlineService.addOffline(defaultSite.id, "GeoLocationBranchVisits", result);
            }
            setLocations(result.data);
            setBackDrop(false);
        },
        (error) => {
            console.log(error);
            setBackDrop(false);
        });
    };

    const getAppVisitationTypes = () => {
        setBackDrop(true);
        HttpService.post('/VisitationEVS/GetAppVisitationTypes')
        .then(async (result) => {
            if (result && result.offline) {
                //get offline data
                const offlineResult = await offlineService.getOfflinesBySite(defaultSite.id, "AppVisitationTypes");
                result.data = offlineResult.OfflineData.data;
            }
            else {
                offlineService.removeOfflineBySite(defaultSite.id, "AppVisitationTypes");
                offlineService.addOffline(defaultSite.id, "AppVisitationTypes", result);
            }

            let allTypes = result.data;
            setAppVisitationTypes({ yesNo: allTypes.filter(x => x.SubType === "YesNo") });
            setAppVisitationTypes({ issueTypes: allTypes.filter(x => x.SubType === "IssueType") });
            setAppVisitationTypes({ priorityTypes: allTypes.filter(x => x.SubType === "Priority") });
            setAppVisitationTypes({ followUps: allTypes.filter(x => x.SubType === "FollowUpType") });
            setBackDrop(false);
        },
        (error) => {
            console.log(error);
            setBackDrop(false);
        });
    };

    const getAppVisitationRecoveries = () => {
        var model = visitationRecovery;

        if (props.location.data) {
            model.AppVisitation = props.location.data.AppVisitationId;
            model.GeoLocation = props.location.data.GeoLocation;
            model.SiteId = props.location.data.SiteId;
            model.VisitDate = props.location.data.VisitDate;
            setVisitDate(props.location.data.VisitDate);
        }
        setBackDrop(true);
        HttpService.post('/RecoveryEVS/GetAppVisitationRecoveries', model)
        .then(async (result) => {
            if (result && result.offline) {
                //get offline data
                const offlineResult = await offlineService.getOfflinesBySite(defaultSite.id, "AppVisitationRecoveries");
                if (props.location.data) {
                    const visitOfflineResult = await offlineService.getOfflinesBySite(defaultSite.id, "AppVisitations");
                    const data = visitOfflineResult.OfflineData.data;
                    const tempData = data.filter(d => d.AppVisitationId === props.location.data.AppVisitationId)[0].recoveries;

                    if (tempData === undefined) {
                        const data = offlineResult.OfflineData.data === null ? [] : offlineResult.OfflineData.data;
                        result.data = data.filter(d => d.AppVisitation === props.location.data.AppVisitationId);
                    }
                    else {
                        result.data = tempData;
                    }
                }
                else
                    result.data = offlineResult.OfflineData.data === null ? [] : offlineResult.OfflineData.data;
            }
            else if (model.AppVisitationRecovery === 0 && model.GeoLocation === 0 && model.IssueTypeId === 0 && model.PriorityId === 0 && model.Resolved === false && model.VisitDate === ConvertToCurrentTimeZone(new Date(), "MM/DD/YYYY hh:mm a", null, defaultSite)) {
                offlineService.removeOfflineBySite(defaultSite.id, "AppVisitationRecoveries");
                offlineService.addOffline(defaultSite.id, "AppVisitationRecoveries", result);
            }
            setRecoveries({ ...recoveries, data: result.data });
            setBackDrop(false);
            if (props.location.data) {
                setOpen(true);
            }
        },
        (error) => {
            console.log(error);
            setBackDrop(false);
        });
    };

    useEffect(() => {
        if (props.location.data) {
            setAppVisitationTypes({ yesNo: props.location.appVisitationTypes.yesNo });
            setAppVisitationTypes({ issueTypes: props.location.appVisitationTypes.issueTypes });
            setAppVisitationTypes({ priorityTypes: props.location.appVisitationTypes.priorityTypes });
            setAppVisitationTypes({ followUps: props.location.appVisitationTypes.followUps });
            setVisitation(props.location.data);
            setRecordToBeEdit([]);
            setAction('Edit');
            setSelectedLocation(props.location.location);
        }
        else {
            if (assignedUsers.length === 0 || assignedUsers[0].uniBrief !== defaultSite.houseCode.toString()) {
                getAssignedToUsers();
            }
            getLocations();
            getAppVisitationTypes();
        }
        // eslint-disable-next-line 
    }, []);

    useEffect(() => {
        if (action === "") {
            getAppVisitationRecoveries();
        }
        // eslint-disable-next-line 
    }, [selectedDate, visitationRecovery.GeoLocation, visitationRecovery.IssueTypeId, visitationRecovery.PriorityId, visitationRecovery.Resolved]);

    return (
        <React.Fragment>
            <ThemeProvider theme={currentTheme}>
                <CssBaseline />
                <Backdrop className={classes.backdrop} id="recoveryBackdrop" open={backDrop}>
                    <CircularProgress color="inherit" />
                </Backdrop>
                <Snackbar open={openSuccess} autoHideDuration={3000} onClose={closeSuccessSnackbar} style={{ height: "100%" }}>
                    <Alert onClose={closeSuccessSnackbar} severity="success">
                        {successMessage}
                    </Alert>
                </Snackbar>
                <Container maxWidth="xl" height="100%" className={props.styles}>
                    <AppBar style={{ background: currentTheme.primary, color: currentTheme.color }}>
                        <Toolbar>
                            {!open && <Link to="/"><KeyboardBackspaceIcon /></Link>}
                            {open &&
                                <IconButton edge="start" color="inherit" onClick={triggerSave} aria-label="back">
                                    <KeyboardBackspaceIcon />
                                </IconButton>
                            }
                            <Grid container direction="row" alignItems="center">
                                <Grid item>
                                    <Typography variant="h6" className={classes.title}>&nbsp;{action} Recovery EVS</Typography>
                                </Grid>
                                <Grid item>
                                    <StatusIcon />
                                </Grid>
                            </Grid>
                            <Grid container justify="flex-end">
                                {!open && <Fab style={{ background: currentTheme.secondary, color: "white" }} size="small" aria-label="add" onClick={openAddVisitation}>
                                    <AddIcon />
                                </Fab>
                                }
                                {open && <Fab style={{ background: currentTheme.secondary, color: "white" }} size="small" aria-label="close" onClick={closeAddVisitation}>
                                    <CloseIcon />
                                </Fab>
                                }
                                <SmallMenu moduleName={"Recovery"} modified={modified} saveCallback={triggerSave} />
                            </Grid>
                        </Toolbar>
                    </AppBar>
                    <Card color="primary" style={{ height: "100%", background: currentTheme.background }}>
                        <CardBody style={{ color: currentTheme.text, marginTop: "50px" }}>
                            <div className={classes.root} autoComplete="off">
                                {(action === "") &&
                                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                        <KeyboardDatePicker disableToolbar autoOk
                                            variant="inline"
                                            inputVariant="outlined"
                                            id="VisitDate"
                                            label="Visit Date"
                                            format="MM/dd/yyyy"
                                            size="small"
                                            disableFuture="true"
                                            value={selectedDate}
                                            onChange={date => dateChanged(date)}
                                            InputAdornmentProps={{ position: "start" }}
                                            PopoverProps={{
                                                anchorOrigin: { horizontal: "left", vertical: "bottom" },
                                                transformOrigin: { horizontal: "left", vertical: "top" }
                                            }}
                                        />
                                    </MuiPickersUtilsProvider>
                                }
                                {(action !== "") &&
                                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                        <KeyboardDateTimePicker hideTabs autoOk
                                            variant="inline"
                                            inputVariant="outlined"
                                            id="VisitDateTime"
                                            label="Visit Date"
                                            format="MM/dd/yyyy hh:mm a"
                                            size="small"
                                            disableFuture="true"
                                            value={visitDate}
                                            onChange={date => visitDateChanged(date)}
                                            disabled={action === "Edit"}
                                            InputAdornmentProps={{ position: "start" }}
                                            PopoverProps={{
                                                anchorOrigin: { horizontal: "left", vertical: "bottom" },
                                                transformOrigin: { horizontal: "left", vertical: "top" }
                                            }}
                                        />
                                    </MuiPickersUtilsProvider>
                                }
                                <Typeahead
                                    style={{ color: (action === "Edit" ? "black" : "") }}
                                    id="LocationList"
                                    labelKey="name"
                                    placeholder="Choose a Location..."
                                    options={locations}
                                    selected={selectedLocation}
                                    disabled={action === "Edit"}
                                    onChange={(e) => locationChanged(e)}
                                    renderMenuItemChildren={(option, key) => (
                                        <>
                                            <div className="dropdown-widget">
                                                <div className="left">{getShortName(option.name)}</div>
                                            </div>
                                        </>
                                    )}
                                />
                                {!open &&
                                    <FormControl variant="outlined" margin="dense" className={classes.ddl}>
                                        <InputLabel htmlFor="IssueType">Issue Type</InputLabel>
                                        <Select
                                            native
                                            label="Issue Type"
                                            size="small"
                                            value={visitationRecovery.IssueType}
                                            onChange={(e) => { setVisitationRecovery({ ...visitationRecovery, IssueTypeId: parseInt(e.target.value) }); }}
                                        >
                                            <option aria-label="None" key="0" value="0" />
                                            {
                                                appVisitationTypes.issueTypes.map((option, key) => {
                                                    return <option key={option.AppVisitationTypeId} value={option.AppVisitationTypeId} label={option.Title} >{option.Title}</option>;
                                                })
                                            }
                                        </Select>
                                    </FormControl>
                                }
                                {!open &&
                                    <FormControl variant="outlined" margin="dense" className={classes.ddl}>
                                        <InputLabel htmlFor="Priority">Priority</InputLabel>
                                        <Select
                                            native
                                            label="Priority"
                                            size="small"
                                            value={visitationRecovery.Priority}
                                            onChange={(e) => { setVisitationRecovery({ ...visitationRecovery, PriorityId: parseInt(e.target.value) }); }}
                                        >
                                            <option aria-label="None" key="0" value="0" />
                                            {
                                                appVisitationTypes.priorityTypes.map((option, key) => {
                                                    return <option key={option.AppVisitationTypeId} value={option.AppVisitationTypeId} label={option.Title} >{option.Title}</option>;
                                                })
                                            }
                                        </Select>
                                    </FormControl>
                                }
                                {!open &&
                                    <FormControlLabel
                                        style={{ width: 'auto', margin: '0px 5px', color: 'inherit' }}
                                        value="end"
                                        control={<Checkbox color="primary" checked={visitationRecovery.Resolved} />}
                                        label="Exclude Closed Recoveries"
                                        labelPlacement="end"
                                        onChange={e => setVisitationRecovery({ ...visitationRecovery, Resolved: e.target.checked })}
                                    />
                                }
                            </div>
                            <Divider style={{ height: '1px', backgroundColor: currentTheme.secondary, marginTop: '5px', marginBottom: '10px' }} />
                            <div style={{ maxWidth: '100%' }}>
                                {!open &&
                                    <MaterialTable
                                        title=""
                                        columns={recoveries.columns}
                                        data={recoveries.data}
                                        onRowClick={(event, rowData) => { editRecovery(event, rowData); }}
                                        components={{
                                            Toolbar: (props) => (
                                                <div
                                                    style={{
                                                        height: "0px",
                                                    }}
                                                >
                                                    <MTableToolbar {...props} />
                                                </div>
                                            )
                                        }}
                                        style={{ backgroundColor: currentTheme.background, border: '1px solid white' }}
                                        options={{
                                            filtering: false,
                                            search: false,
                                            paging: false,
                                            actionsColumnIndex: -1,
                                            minBodyHeight: tableHeight,
                                            maxBodyHeight: tableHeight,
                                            headerStyle: {
                                                fontWeight: 'bold', color: currentTheme.headerColor, backgroundColor: currentTheme.headerBackground
                                            },
                                            actionsCellStyle: {
                                                color: currentTheme.secondary,
                                                hover: 'white'
                                            },
                                            rowStyle: rowStyle
                                        }}
                                        actions={[
                                            {
                                                icon: EditIcon,
                                                tooltip: 'Edit Recovery EVS',
                                                onClick: (event, rowData) => { editRecovery(event, rowData); }
                                            }
                                        ]}
                                    />
                                }

                                {open && <RecoveryEVSAdd ref={recoveryRef}
                                    key={visitationRecovery.AppVisitationId} 
                                    parentCallback={closeAddVisitation}
                                    refreshGrid={updateList}
                                    appVisitationTypes={appVisitationTypes}
                                    recoveries={recoveries.data}
                                    model={recordToBeEdit}
                                    visitDate={visitDate}
                                    location={selectedLocation}
                                    visitation={visitation}
                                    theme={currentTheme}
                                    inputValueChanged={inputValueChanged}
                                />
                                }
                            </div>
                        </CardBody>
                    </Card>
                </Container>
            </ThemeProvider>
        </React.Fragment>
    )
}
